<template>
  <div class="base-container">
    <v-row
      :style="setBackgroundColor"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3' : 'pt-10'"
      align="center"
      justify="space-between"
      no-gutters
    >
      <v-col cols="12" md="4" class="d-flex align-center justify-center">
        <h3 class="secondary-font text--secondary py-5">
          Agendamentos
        </h3>
      </v-col>
      <v-col cols="12" md="4" class="pb-0 d-flex align-center justify-center">
        <slot name="tabs"></slot>
      </v-col>
    </v-row>
    <v-row no-gutters class="h-90">
      <v-col cols="12">
        <v-tabs-items v-model="tab" class="fill-height pt-10 bg-default">
          <v-tab-item value="tab-abertos">
            <v-container>
              <v-row>
                <slot name="tabAbertos"></slot>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item value="tab-finalizados">
            <v-container>
              <v-row>
                <slot name="tabFinalizados"></slot>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item value="tab-ambulatoriais">
            <v-container>
              <v-row>
                <slot name="tabAmbulatoriais"></slot>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: String
  },
  computed: {
    tab: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    setBackgroundColor() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return { backgroundColor: '#F7F7F7' }
      }
      return {}
    }
  }
}
</script>
